import { createSlice } from '@reduxjs/toolkit';

export const templatesSlice = createSlice({
    name: 'templates',
    initialState: {
        templates: [],
        templatesLoading: false,
        templatesLoadingMore: false,
        templatesError: null,
        projectData: {},
        page: 1,
        perPage: 10,
        totalPages: 1,
        totalItems: 0,
        hasMore: true,
        searchTerm: ''
    },

    reducers: {
        
        setTemplatesRes: (state: any, action) => {
            state.templates = action?.payload?.templates || []
            state.totalItems = action?.payload?.total || 0
            state.totalPages = action?.payload?.pages || 1
            state.page = action?.payload?.page || 1
            state.perPage = action?.payload?.per_page || 10
            state.hasMore = state.page < state.totalPages
        },
        appendTemplatesData: (state: any, action) => {
            state.templates = [...state.templates, ...(action?.payload?.templates || [])]
            state.totalItems = action?.payload?.total || 0
            state.totalPages = action?.payload?.pages || 1
            state.page = action?.payload?.page || 1
            state.perPage = action?.payload?.per_page || 10
            state.hasMore = state.page < state.totalPages
        },
        setTemplatesError: (state: any, action) => {
            state.templatesError = action.payload
        },
        setTemplatesLoading: (state: any, action) => {
            state.templatesLoading = action.payload
        },
        setTemplatesLoadingMore: (state: any, action) => {
            state.templatesLoadingMore = action.payload
        },
        setTemplateByIdRes: (state: any, action) => {
            state.projectData = action.payload
        },
        resetTemplatesPagination: (state) => {
            state.page = 1
            state.hasMore = true
        },
        setTemplatesSearchTerm: (state: any, action) => {
            state.searchTerm = action.payload
            state.page = 1
            state.hasMore = true
        }
    }
});

export const { 
    setTemplatesRes, setTemplatesLoading, setTemplatesError,
    setTemplateByIdRes, appendTemplatesData, setTemplatesLoadingMore,
    resetTemplatesPagination, setTemplatesSearchTerm
} = templatesSlice.actions;

export default templatesSlice.reducer;
